import React, { useContext } from "react";
import PropTypes from "prop-types";

import { formatCurrency } from "functions/formatCurrency";
import { AwardsByTermContext } from "./AwardsByTermContext";

export function AmountCell({ amount }) {
  const { useDecimals } = useContext(AwardsByTermContext);

  if (amount === null) {
    return <td style={{ textAlign: `right` }}>N/A</td>;
  }

  return (
    <td style={{ textAlign: `right` }}>
      {formatCurrency(amount, { showDecimals: useDecimals })}
    </td>
  );
}

AmountCell.propTypes = {
  amount: PropTypes.number,
};
